import { editPersonalization } from '../personalization';
import { replaceOperation } from '../../product/operations';

import { ENABLED, OPERATIONS, REQUIRED } from '../../../constants/product';
import { ATTRIBUTE } from '../../../constants/attributes';
import { EMPTY } from '../../../constants';
import { ETSY } from '../../../constants/channels';
import { FORM } from '../../../constants/forms';

export function personalization({ operation, product, ...rest }) {
  const operationType = operation.get('type');

  switch (operationType) {
    case OPERATIONS[ETSY].PERSONALIZATION.CHAR_COUNT_MAX_SET: {
      if (!product.getIn([FORM.PERSONALIZATION, ENABLED])) {
        return { product, ...rest };
      }

      const value = operation.get('value');
      const updates = editPersonalization({ product, [ATTRIBUTE.CHAR_COUNT_MAX]: value });
      return {
        ...rest,
        product: updates.product = updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_SET: {
      if (!product.getIn([FORM.PERSONALIZATION, ENABLED])) {
        return { product, ...rest };
      }

      const value = operation.get('value');
      const updates = editPersonalization({ product, [ATTRIBUTE.INSTRUCTIONS]: value });
      return {
        ...rest,
        product: updates.product = updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case OPERATIONS[ETSY].PERSONALIZATION.IS_PERSONALIZABLE_SET: {
      const value = operation.get('value');
      const updates = editPersonalization({ product, [ENABLED]: value });
      return {
        ...rest,
        product: updates.product = updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case OPERATIONS[ETSY].PERSONALIZATION.IS_REQUIRED_SET: {
      if (!product.getIn([FORM.PERSONALIZATION, ENABLED])) {
        return { product, ...rest };
      }

      const value = operation.get('value');
      const updates = editPersonalization({ product, [REQUIRED]: value });
      return {
        ...rest,
        product: updates.product = updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    default: {
      return { product, ...rest };
    }
  }
}
